import PropTypes from 'prop-types';

import { AppTabsRouter, AppTabsRouterItem } from '@/components/app-layout/TabsRouter';
import { useParams } from '@Components/RouterProvider';

const propTypes = {
  id: PropTypes.string,
};

export default function AllocationTabsRouter() {
  const { id } = useParams()

  if (!id) return null

  return <AppTabsRouter>
    <AppTabsRouterItem exact to={`/offer/allocations/${id}`}>
      Details
    </AppTabsRouterItem>
    <AppTabsRouterItem to={`/offer/allocations/${id}/subids`}>
      SubIDS
    </AppTabsRouterItem>
    <AppTabsRouterItem to={`/offer/allocations/${id}/buckets`}>
      Revenue Scrub
    </AppTabsRouterItem>
    <AppTabsRouterItem to={`/offer/allocations/${id}/transactions`}>
      Transactions
    </AppTabsRouterItem>
  </AppTabsRouter >
}

AllocationTabsRouter.propTypes = propTypes
AllocationTabsRouter.defaultProps = {}

